export default __webpack_public_path__ + "static/media/seguin.c8d25847.png";